import React from 'react';
import PropTypes from 'prop-types';
import PageHelmet from '@bd/bdcore-pagehelmet';
import { get } from 'lodash';
import withData from '@bd/bdcore-data';
import { css } from '@bd/bdui-styles/emotion';
import PageWrapper from '../../components/PageWrapper';
import Overview from './Overview';
import InsideHeader from '../../components/InsideHeader';
import ContactBanner from '../../components/ContactBanner';
import SectionAbout from './SectionAbout';
import SectionPlan from './SectionPlan';
import SectionDirections from '../../components/SectionDirections';
import Menu from './Menu';
import { colors, typography } from '../../styles';

const styles = css`
  background-color: ${colors.color3};
  .HomeDetail_main {

  }
  .HomeDetail_sectionHead {
    font-family: ${typography.SerifHead};
    font-weight: bold;
    letter-spacing: 0.62px;
    font-style: italic;
    margin-bottom: 0.625em;
  }
`;


function HomeDetail({ agent, builder, community, home, widget }) {
  return (
    <PageWrapper className={styles} builder={builder} agent={agent}>
      <PageHelmet home={home} />
      <InsideHeader
        title={get(widget, 'page_title')}
        background={get(widget, 'page_image.contentUrl')}
      />
      <Menu />
      <main className="HomeDetail_main" id="page-content">
        <Overview agent={agent} builder={builder} community={community} home={home} />
      </main>
      <SectionAbout
        description={get(home, 'description')}
      />
      {get(home, 'floorplanPhotos') &&
        <SectionPlan photos={get(home, 'floorplanPhotos')} />
      }
      {
        <SectionDirections
          directions={get(home, 'directions')}
          marker={home}
        />
      }
      <ContactBanner formName="homeQuickContact" formLabel="Home Quick Contact" />
    </PageWrapper>
  );
}

HomeDetail.propTypes = {
  agent: PropTypes.object.isRequired,
  builder: PropTypes.object.isRequired,
  community: PropTypes.object,
  home: PropTypes.object.isRequired,
  widget: PropTypes.object.isRequired,
};

HomeDetail.defaultProps = {
  community: undefined,
};


export default withData(
  {
    widget: 'homes',
    builder: true,
    home: true,
    community: true,
    agent: true,
  },
  {
    required: {
      builder: true,
      home: true,
      agent: true,
      widget: true,
    },
    ifMissing404: true,
  },
)(HomeDetail);



// WEBPACK FOOTER //
// ./src/pages/HomeDetail/index.js